// ADD YOUR OWN GOOGLE MAPS API KEY HERE
export const API_KEY = 'AIzaSyDpkXj6w-FuBKw8uAMRuQWZKtYtdNsYz4w'
